import * as React from 'react'
import { ButtonProps } from '@material-ui/core/Button'
import { useEffect, useState } from 'react'
import { GoalId, UserId } from '../../../../services/api.types'
import { getChatClient, channelType, requestAndRegisterPushToken } from '../../hooks/useInitChat'
import { t } from 'ttag'
import Box from '@material-ui/core/Box'
import YumButton from '../../../../components/YumButton/YumButton'
import { App } from '@capacitor/app'
import { PluginListenerHandle } from '@capacitor/core'
import { StreamChat } from 'stream-chat'
import { isRtl } from '../../../../i18nInit'
import YumTab from '../../../../components/YumTabs/YumTab/YumTab'
import { ChallengeTab } from '../../../../components/YumChallengeTabs/YumChallengeTabs'
import { isNative } from '../../../../common/helpers/isNative'
//import { PushNotifications } from '@capacitor/push-notifications'
import { FirebaseMessaging } from '@capacitor-firebase/messaging'
import Bugsnag from '@bugsnag/js'

interface YumChatButtonProps extends ButtonProps {
  userId: UserId
  goalId: GoalId
  name: string
  connect: boolean
  participating?: boolean
  tab?: ChallengeTab
  currentRoute?: Partial<Location>
}

const YumChatButton = (props: YumChatButtonProps) => {
  const { userId, goalId, name, connect, participating, tab, currentRoute, ...otherProps } = props
  const [unreadCount, setUnreadCount] = useState(0)
  let chatNewMsgListener: { unsubscribe: any }
  let appStateChangeListener: PluginListenerHandle
  let client: StreamChat | undefined
  //let pushNotificationsRegisterListener: PluginListenerHandle

  const updateUnreadCount = (count: number) => {
    const isChatPage = document.body.classList.contains('challenge-view__chat')
    setUnreadCount(isChatPage ? 0 : count)
  }

  const initChatWatch = async (userId: UserId, goalId: GoalId) => {
    console.log('initChatWatch')
    try {
      client = await getChatClient(userId, name)
      if (!client) throw new Error('getChatClient failed')

      const channel = client.channel(channelType, goalId)
      await channel.watch()

      updateUnreadCount(channel.countUnread())

      chatNewMsgListener = channel.on('message.new', (event: any) => {
        updateUnreadCount(channel.countUnread())
      })

      appStateChangeListener = await App.addListener('appStateChange', async ({ isActive }) => {
        try {
          if (isActive) {
            // Possible error: User is not set on client, use client.connectUser or client.connectAnonymousUser instead.
            await client?.openConnection()
            await client?.recoverState()

            await channel.watch()
            const unread = channel.countUnread()
            updateUnreadCount(unread)
          } else {
            await client?.closeConnection()
          }
        } catch (e: any) {
          // It's fine if it fails.
          /*Bugsnag.notify(new Error('log error'), function (event) {
            event.context = 'log'
            event.addMetadata('error', {
              error: e,
            })
          })
          console.error(e.message)*/
        }
      })

      if (isNative()) {
        console.log('PushNotifications.register() | ranking view')
        await requestAndRegisterPushToken(client, userId)
      }
    } catch (e: any) {
      // It's fine if it fails.
    }
  }

  useEffect(() => {
    /*if (connect) {
      initChatWatch(userId, goalId)
    }*/
    return () => {
      console.log('YumChatButton unmount')

      appStateChangeListener?.remove()
      //pushNotificationsRegisterListener?.remove()

      try {
        console.log('chatNewMsgListener?.unsubscribe()')
        chatNewMsgListener?.unsubscribe()
      } catch (e: any) {
        console.error('YumChatButton unmount chatNewMsgListener?.unsubscribe() failed', e)
      }

      setTimeout(() => {
        console.log('client?.disconnectUser()')
        try {
          client?.disconnectUser()
        } catch (e: any) {
          // It's fine if it fails.
          // console.log('YumChatButton unmount disconnectUser failed', e)
        }
      }, 0)
    }
  }, [])

  useEffect(() => {
    console.log('YumChatButton | participating: ', participating, ' | connect: ', connect, ' | client: ', !!client)
    if (connect && participating && !client) {
      console.log('YumChatButton | triggering initChatWatch')
      initChatWatch(userId, goalId)
    }
  }, [connect, participating])

  useEffect(() => {
    const pathParts = currentRoute && currentRoute.pathname ? currentRoute.pathname.split('/') : []
    if (pathParts[3] === 'chat') {
      updateUnreadCount(0)
    }
  }, [currentRoute?.pathname])

  const content = (
    <>
      {t`Chat`}
      {unreadCount > 0 ? (
        <Box
          style={
            tab
              ? {
                  marginLeft: '4px',
                  display: 'inline-block',
                  position: 'relative',
                  top: '-1px',
                  //right: -7,
                  background: 'red',
                  padding: '2px 4px',
                  lineHeight: 1,
                  borderRadius: '10px',
                  //border: '2px solid white',
                  fontSize: '8px',
                  color: 'white',
                }
              : {
                  position: 'absolute',
                  top: -7,
                  right: -7,
                  background: 'red',
                  padding: '2px 4px',
                  lineHeight: 1,
                  borderRadius: '10px',
                  border: '2px solid white',
                  fontSize: '8px',
                }
          }
        >
          {unreadCount > 25 ? '25+' : unreadCount}
        </Box>
      ) : (
        ''
      )}
    </>
  )

  return !tab ? (
    <YumButton
      size="small"
      style={isRtl ? { marginRight: '10px' } : { marginLeft: '10px' }}
      to={`/challenges/${goalId}/chat`}
    >
      {content}
    </YumButton>
  ) : (
    // @ts-ignore
    <YumTab value={tab} label={content} {...otherProps} />
  )
}

export default YumChatButton
